import React, { useState, useCallback } from 'react';
import { Volume2, VolumeX } from 'lucide-react';
import { Button } from '../ui/button';

/**
 * PM Spec V3 13/05/2026 — AudioInstruction
 * Bouton 🔊 qui lit une consigne via Web Speech API (gratuit, FR).
 * Optimisé pour utilisateurs faiblement alphabétisés.
 */
const AudioInstruction = ({ text, lang = 'fr-FR', testId = 'audio-instruction', size = 'sm' }) => {
  const [speaking, setSpeaking] = useState(false);

  const speak = useCallback(() => {
    if (!('speechSynthesis' in window) || !text) return;
    try {
      window.speechSynthesis.cancel();
      const u = new SpeechSynthesisUtterance(text);
      u.lang = lang;
      u.rate = 0.9;
      u.onstart = () => setSpeaking(true);
      u.onend = () => setSpeaking(false);
      u.onerror = () => setSpeaking(false);
      window.speechSynthesis.speak(u);
    } catch { /* noop */ }
  }, [text, lang]);

  const stop = useCallback(() => {
    try { window.speechSynthesis.cancel(); } catch { /* noop */ }
    setSpeaking(false);
  }, []);

  if (!text) return null;
  return (
    <Button
      type="button"
      variant="ghost"
      size={size}
      data-testid={testId}
      onClick={speaking ? stop : speak}
      className="text-emerald-700 hover:bg-emerald-50 gap-1"
      aria-label={speaking ? 'Arrêter la lecture' : 'Lire à voix haute'}
    >
      {speaking ? <VolumeX className="w-4 h-4" /> : <Volume2 className="w-4 h-4" />}
      <span className="text-xs font-medium">{speaking ? 'Stop' : 'Écouter'}</span>
    </Button>
  );
};

export default AudioInstruction;
